import React from 'react';
import PropTypes from 'prop-types';
import View from '@loggi/ui/components/view';
import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import Icon from '@loggi/ui/components/icon';
import icons from '@loggi/ui/components/utils/icons';
import colors from '@loggi/ui/components/utils/colors';
import MainView from 'shared/main-view/main-view.component';
import {
  NUMBERED_LIST,
  CONTESTATION_MESSAGE,
  CONTESTATION_MESSAGE_ITEM_ONE,
  CONTESTATION_MESSAGE_ITEM_TWO_BEGIN,
  CONTESTATION_MESSAGE_ITEM_TWO_END,
  CONTESTATION_MESSAGE_ITEM_THREE,
  CONTESTATION_MESSAGE_ITEM_FOUR_BEGIN,
  CONTESTATION_MESSAGE_ITEM_FOUR_END,
  ATENTION_CARD_MESSAGE_TITLE,
  ATENTION_CARD_MESSAGE_CONTENT_BEGIN,
  ATENTION_CARD_MESSAGE_CONTENT_END,
  CONTESTATION_QUESTION
} from './start-contest.constants';

import styles from '../confirm-delivery.styles.scss';

export default function StartContestMain({ receivedBy }) {
  return (
    <MainView>
      <View
        flex
        flexDirection="column"
        flexGrow="1"
        gutter={{
          left: 'double',
          right: 'double',
          bottom: 'double'
        }}
        justifyContent="between"
      >
        <Text className={styles.newConfirmDelivery} color={colors.type.DARK}>
          {CONTESTATION_MESSAGE}
        </Text>
        <Col
          flex
          flexDirection="row"
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Col className={styles.confirmDeliveryIcon}>
            <Text color={colors.type.ACTIVE} bold>
              {NUMBERED_LIST.NUMBER_ONE}
            </Text>
          </Col>
          <Text color={colors.type.DARK}>{CONTESTATION_MESSAGE_ITEM_ONE}</Text>
        </Col>
        <Col
          flex
          flexDirection="row"
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Col className={styles.confirmDeliveryIcon}>
            <Text color={colors.type.ACTIVE} bold>
              {NUMBERED_LIST.NUMBER_TWO}
            </Text>
          </Col>

          <Text color={colors.type.DARK}>
            {CONTESTATION_MESSAGE_ITEM_TWO_BEGIN}
            <Text color={colors.type.ACTIVE}>{`${receivedBy}`}</Text>
            {CONTESTATION_MESSAGE_ITEM_TWO_END}
          </Text>
        </Col>
        <Col
          flex
          flexDirection="row"
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Col className={styles.confirmDeliveryIcon}>
            <Text color={colors.type.ACTIVE} bold>
              {NUMBERED_LIST.NUMBER_THREE}
            </Text>
          </Col>

          <Text color={colors.type.DARK}>
            {CONTESTATION_MESSAGE_ITEM_THREE}
          </Text>
        </Col>

        <Col
          flex
          flexDirection="row"
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Col className={styles.confirmDeliveryIcon}>
            <Text color={colors.type.ACTIVE} bold>
              {NUMBERED_LIST.NUMBER_FOUR}
            </Text>
          </Col>

          <Text color={colors.type.DARK}>
            {CONTESTATION_MESSAGE_ITEM_FOUR_BEGIN}
            <Text color={colors.type.ACTIVE}>{`${receivedBy} `}</Text>
            {CONTESTATION_MESSAGE_ITEM_FOUR_END}
          </Text>
        </Col>

        <Col className={styles.colorNew}>
          <Col
            flex
            flexDirection="row"
            alignItems="start"
            gutter={{
              top: 'double',
              right: 'double',
              left: 'double',
              bottom: 'double'
            }}
          >
            <Col className={styles.confirmDeliveryIcon}>
              <Icon
                color={colors.type.WARNING_DARKER}
                type={icons.type.ALERT}
              />
            </Col>
            <Col flexDirection="column">
              <Text color={colors.type.DARKEST}>
                {ATENTION_CARD_MESSAGE_TITLE}
              </Text>
              <Col
                gutter={{
                  top: 'double'
                }}
              >
                <Text color={colors.type.DARK}>
                  {ATENTION_CARD_MESSAGE_CONTENT_BEGIN}
                  <Text color={colors.type.DARKEST}>{`${receivedBy} `}</Text>
                  {ATENTION_CARD_MESSAGE_CONTENT_END}
                </Text>
              </Col>
            </Col>
          </Col>
        </Col>

        <Col
          flex
          alignItems="center"
          gutter={{
            top: 'double',
            right: 'double'
          }}
        >
          <Text color={colors.type.DARK}>{CONTESTATION_QUESTION}</Text>
        </Col>
      </View>
    </MainView>
  );
}

StartContestMain.displayName = 'StartContestMain';

StartContestMain.propTypes = {
  receivedBy: PropTypes.string.isRequired
};
